import {
  AssessmentId,
  BulkRiskUpdate,
  CreateReviewAction,
  CreateRiskContext,
  OwnerId,
  RiskContextId,
  RiskId,
  RiskIdPair,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function load(riskIds: RiskIdPair[]) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/tprm/risks/load", {body: riskIds});
}

export async function assign(riskId: RiskId, ownerId: OwnerId | null) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/risks/{risk_id}/owner", {
    path: {risk_id: riskId},
    body: ownerId,
  });
  await invalidateQueries([q.tprm.risk.filter()]);
  return res;
}

export async function loadContexts(contextIds: RiskContextId[]) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/tprm/risk_contexts/load", {
    body: contextIds,
  });
}

export async function addContext(riskId: RiskId, context: CreateRiskContext) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/risks/{risk_id}/contexts", {
    path: {risk_id: riskId},
    body: context,
  });
  return res;
}

export async function delete_(riskId: RiskId, assessmentId: AssessmentId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/risks/{risk_id}", {
    path: {risk_id: riskId},
  });
  await invalidateQueries([q.tprm.assessmentRisks.filter(assessmentId), q.tprm.assessmentNodes.filter(assessmentId)]);
  return res;
}

export async function bulkUpdate(update: BulkRiskUpdate) {
  const res = await platformedClient.internalRequest("patch", "/region/{region}/api/tprm/risks", {body: update});
  await invalidateQueries([q.tprm.assessmentRisks.filter(), q.tprm.assessment.filter(), q.tprm.risk.filter()]);
  return res;
}

export async function createReviews(riskId: RiskId, requests: CreateReviewAction[]) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/risks/{risk_id}/reviews", {
    path: {risk_id: riskId},
    body: requests,
  });
  await invalidateQueries([
    q.tprm.assessmentRisks.filter(),
    q.tprm.assessment.filter(),
    q.tprm.risk.filter(),
    q.reviewable.filter(),
  ]);
  return res;
}
